<template>
  <div>
    <div class="big-title">
      <span>抽样品种及污染物选择</span>
    </div>
    <a-row>
      <a-row :gutter="4">
        <a-col :span="4">
          <span class="list-header">抽样品种选择</span>
        </a-col>
        <a-col :span="6">
          <span class="list-header">抽样比例</span>
        </a-col>
        <a-col :span="11">
        </a-col>
        <a-col :span="3">
        </a-col>
      </a-row>
      <a-row v-for="item in localValue" :gutter="4" :style="{margin:'4px'}">
        <a-col :span="4">
          <a-ext-check-box :disabled="disabled" :label="item.produceName" v-model="item.checked" width="90%">
          </a-ext-check-box>
        </a-col>
        <a-col :span="6">
          <a-input-number
                  v-model="item.pickPercent"
                  :disabled="disabled"
                  allowClear
                  :min="0"
                  :max="100"
                  :formatter="value => `${value}%`"
                  :parser="value => value.replace('%', '')"
                  placeholder="请输入抽检数量"></a-input-number>
        </a-col>
        <a-col :span="11">

        </a-col>
        <a-col :span="3">

        </a-col>
      </a-row>
    </a-row>
    <bad-check-panel-modal  v-if="modalVisable" :visible.sync="modalVisable"
                                :param="modalParam"
                                @dialogBack="onModalClose"></bad-check-panel-modal>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
import AExtCheckBox from './AExtCheckBox'
import BadCheckPanelModal from './BadCheckPanelModal'

export default {
    name: "index",
    mixins:[mixin],
    components:{AExtCheckBox,BadCheckPanelModal},
    props:{
        hangye:{
            type:String,
            default: ''
        },
        needCheck:{
            type:Boolean,
            default:false
        },
        badStdId:{
            type:String,
            default:''
        },
        disabled:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            localValue: [],
            modalVisable: false,
            modalBackChange: null,
            modalParam: null
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
        },
        reChoice(item){
            this.modalParam={projectId:item.projectId}
            this.modalVisable=true;
            this.modalBackChange=item;
        },
        onModalClose(result){
            let task=this.modalBackChange;
            task.badThings=result.badThings;
        }
    }

}
</script>

<style scoped>
  .box{
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    padding-left: 5px;
    font-weight: 700;
    color: #7c7c7c;
    margin-right: 5px;
  }

  .total-box{
    font-weight: 700;
    color: #7c7c7c;
  }

  /deep/ .ant-select-selection--single{
    height: 40px;
  }

  /deep/ .ant-select{
    vertical-align: top;
  }

  /deep/ .ant-select-selection__rendered{
    line-height: 40px;
    color: #7c7c7c;
    font-weight: 700;
  }

  /deep/ .ant-input-number {
    height: 40px;
    vertical-align: top;
    width: 100%;
  }

  .list-header {
    padding-left: 20px;
    color: #888888;
    font-weight: 700;
  }

  .big-title {
    color: #444444;
    font-weight: 700;
  }
</style>